module.exports = __webpack_public_path__ + "img/inline-tablet-english.5a6be10d.png";